/** Shared by About, onboarding and the billing paywall. */
export function LegalLinks(): React.JSX.Element {
  return (
    <nav aria-label="Legal" className="flex flex-wrap gap-phi-0 text-phi-n1">
      <a className="min-h-[44px] py-phi-n2 underline" href="/terms/">Terms</a>
      <a className="min-h-[44px] py-phi-n2 underline" href="/privacy/">Privacy</a>
    </nav>
  );
}
